document.addEventListener('rebuy:smartcart.ready', () => {
  handleRebuyHooks()
  enableRecommendationCarousel()
});
document.addEventListener('rebuy:smartcart.line-item-decrease', (event) => {
  handleConnectedPersonalization(event, false)
});
document.addEventListener('rebuy:smartcart.line-item-increase', (event) => {
  handleConnectedPersonalization(event, true)
});

function handleConnectedPersonalization (event, increaseQuantity = false) {
  if(!event || !event.detail) return

  const { smartcart, item } = event.detail;
  const relatedPersonalizationKey = item.properties._perso
  let relatedPersonalization = false
  if (relatedPersonalizationKey) {
    const relatedPerso = smartcart.cart.items.find(cartItem => cartItem.properties && cartItem.properties._perso === relatedPersonalizationKey)
    relatedPersonalization = relatedPerso
  }
  if (relatedPersonalization) {
    const Cart = window.Rebuy.Cart;
    if(Cart) {
      const newQuantity = increaseQuantity ? item.quantity + 1 : item.quantity - 1
      Cart.changeItem({
        id: relatedPersonalization.key,
        quantity: newQuantity
      });
    }
  }
}

function cleanUpLeftoversPersonalizations () {
  const rebuyCart = window.Rebuy.Cart;
  if(rebuyCart) {
    rebuyCart.cart.items.forEach(item => {
      if(item.properties && item.properties._perso) {
        const samePersoReference = rebuyCart.cart.items.filter(cartItem => cartItem.properties && cartItem.properties._perso === item.properties._perso)
        if(samePersoReference.length === 1) {
          rebuyCart.changeItem({
            id: item.key,
            quantity: 0
          });
        }
      }
    })
  }
}

document.addEventListener('rebuy:cart.change', (e) => {
  cleanUpLeftoversPersonalizations()
  handleRebuyHooks()
  enableRecommendationCarousel()
});

let rebuySmartCartItems = []
let rebuyWaitForProductDataCounter = 0

const recommendationCarouselPending = new Set()

function enableRecommendationCarousel(attempt = 0) {
  const widgets = window.Rebuy && window.Rebuy.widgets
  if (!widgets || !widgets.length) {
    if (attempt < 10) setTimeout(() => enableRecommendationCarousel(attempt + 1), 200)
    return
  }

  let waitingForLineWidget = true

  widgets.forEach((widget) => {
    const settings = widget.data && widget.data.settings
    const layout = settings && settings.layout
    if (!layout || !layout.large || layout.large.style !== 'line') return

    waitingForLineWidget = false
    const widgetId = String(widget.id)
    if (recommendationCarouselPending.has(widgetId)) return
    if (layout.large.carousel && Number(layout.large.columns) >= 2) return

    const nextSettings = JSON.parse(JSON.stringify(settings))
    ;['large', 'medium', 'small'].forEach((breakpoint) => {
      if (!nextSettings.layout[breakpoint]) return
      nextSettings.layout[breakpoint].carousel = true
      nextSettings.layout[breakpoint].columns = 2
    })

    recommendationCarouselPending.add(widgetId)
    widget.updateWidgetSettings(nextSettings, () => {
      recommendationCarouselPending.delete(widgetId)
    })
  })

  if (waitingForLineWidget && attempt < 10) {
    setTimeout(() => enableRecommendationCarousel(attempt + 1), 200)
  }
}

function handleRebuyHooks() {
  const rebuyPack = document.querySelector("#rebuy-cart .rebuy-cart__pack")

  if(rebuyPack) {
    handleChangesInSmartCart(rebuyPack);

    if (!rebuyPack.classList.contains('event-added')) {
      rebuyPack.classList.add('event-added')
      const inputs = rebuyPack.querySelectorAll('input')

      inputs.forEach((input) => {
        input.addEventListener('click', () => handleSmartCartPackingSelection(rebuyPack))
      })
    }
  } else {
    smartCartUpdatePackingCartAttribute()
  }
}

function smartCartUpdatePackingCartAttribute(newValue = "") {
  const formData = new FormData();
  formData.append("attributes[_packing_type]", newValue);

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    body: formData
  })
  // DEBUG
  // .then(response => response.json())
  // .then(data => console.log(data));
}

function handleSmartCartPackingSelection(packContainer) {
  const selectedPack = packContainer.querySelector('input:checked')
  if (selectedPack) smartCartUpdatePackingCartAttribute(selectedPack.value)
}

function handleChangesInSmartCart(rebuyPack) {
  if(!rebuyPack || rebuyWaitForProductDataCounter > 10) return

  const { SmartCart } = Rebuy;
  const items = SmartCart.items()
  const cartTags = []
  const newProductsInCart = []

  if(items.length && !items[0].product) {
    rebuyWaitForProductDataCounter ++
    setTimeout(() => {
      handleChangesInSmartCart(rebuyPack)
    }, 50);
    return
  }
  rebuyWaitForProductDataCounter = 0

  if (items.length) {
    items.forEach((item) => {
      if (item.product && item.product.tags) {
        const itemTags = item.product.tags.split(', ');
        cartTags.push(...itemTags);
      }
      newProductsInCart.push(item.id)
    })
  }

  if (newProductsInCart.toString() === rebuySmartCartItems.toString()) return
  rebuySmartCartItems = [...newProductsInCart]

  if(!items.length || cartTags.includes('GABARYT')) {
    rebuyPack.classList.remove('enabled')
    smartCartUpdatePackingCartAttribute()
  } else {
    rebuyPack.classList.add('enabled')
    handleSmartCartPackingSelection(rebuyPack)
  }
};